export interface ArUrlParts {
    gcsObjectName: string
    vertical: boolean
}

export const assembleArUrl = (baseUrl: URL, gcsObjectName: string, vertical: boolean): string => {
    const path = `${baseUrl}/${gcsObjectName}`
    return vertical ? `${path}?vertical` : path
}

export const parseArUrl = (url: string): ArUrlParts => {
    const [path, queryParams] = url.split("?")

    const gcsObjectName = path.split("/").pop()
    if (!gcsObjectName) throw new Error("Invalid AR URL")

    const vertical = queryParams?.includes("vertical") || false

    return {
        gcsObjectName,
        vertical,
    }
}
